import React from 'react';
import './Button.style.scss';
import { TButtonTypes } from '#/types/common';

interface IProps {
  handleOnClick?: () => void;
  text: string;
  className?: string;
  type?: TButtonTypes;
}

const Button = (props: IProps) => {
  const { handleOnClick, text, className, type = 'success' } = props;

  return (
    <button
      className={`button ${type} ${className ? className : ''}`}
      onClick={handleOnClick}
    >
      {text}
    </button>
  );
};

export default Button;
